import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";

export default {
  name: "Slider",
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  data() {
    return {
      data: [],
      sliderData: []
    };
  },
  methods: {
    getData() {
      this.$http
        .get(
          "https://app.umw.edu.pl/headless/wp-json/wp/v2/media/?per_page=100"
        )
        .then(function(data) {
          this.data = JSON.parse(JSON.stringify(data)).body;
          // console.log(this.data);

          this.getProperSliderData(this.data);
        });
    },
    getProperSliderData(data) {
      data.forEach(data => {
        if (data.categories[0] == 4) {
          this.sliderData.push(data.source_url);
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
